package com.example.mystybag.database.communication.db.daos

import app.cash.sqldelight.coroutines.asFlow
import app.cash.sqldelight.coroutines.mapToList
import com.example.mystybag.database.communication.db.DatabaseProvider
import com.example.mystybag.database.communication.db.databaseQueryDispatcher
import com.example.mystybag.sharedmodels.project.responseModels.EmbeddingDeltaItem
import kotlinx.coroutines.flow.first

class EmbeddingsDao {
    private val database by lazy { DatabaseProvider.getDatabaseInstance() }
    private val embeddingsQueries = database?.embeddingsQueries

    /**
     * Запазва или обновява embedding (suspend за JS async driver).
     */
    suspend fun upsertEmbedding(item: EmbeddingDeltaItem, lastModifiedIso: String = "") {
        embeddingsQueries?.upsertEmbedding(
            merchantLocationId = item.merchantLocationId,
            cityId = item.cityId,
            lang = item.lang,
            docType = item.docType,
            qScale = item.qScale.toDouble(),
            qZeroPoint = item.qZeroPoint.toLong(),
            vecQint8 = item.vecQint8,
            lastModifiedIso = lastModifiedIso
        )
    }

    /**
     * Запазва или обновява списък от embeddings.
     */
    suspend fun upsertEmbeddings(items: List<EmbeddingDeltaItem>, lastModifiedIso: String = "") {
        items.forEach { item ->
            upsertEmbedding(item, lastModifiedIso)
        }
    }

    /**
     * Брой записи в embeddings (за диагностика – лека заявка).
     */
    suspend fun getEmbeddingsCount(): Long {
        val queries = embeddingsQueries ?: return 0L
        return queries.countEmbeddings()
            .asFlow()
            .mapToList(databaseQueryDispatcher)
            .first()
            .firstOrNull() ?: 0L
    }

    /**
     * Вземи всички embeddings (suspend за JS async driver; използва Flow за да работи на всички платформи).
     */
    suspend fun getAllEmbeddings(): List<EmbeddingDeltaItem> {
        val queries = embeddingsQueries ?: return emptyList()
        return queries.getAllEmbeddings()
            .asFlow()
            .mapToList(databaseQueryDispatcher)
            .first()
            .map { row ->
                EmbeddingDeltaItem(
                    merchantLocationId = row.merchantLocationId,
                    cityId = row.cityId,
                    lang = row.lang,
                    qScale = row.qScale.toFloat(),
                    qZeroPoint = row.qZeroPoint.toInt(),
                    vecQint8 = row.vecQint8,
                    docType = row.docType
                )
            }
    }
}

